import { BelaChatProvider } from "./BelaChatContext";
import BelAiChat from "./BelAiChat";
import BelaChatPanel from "./BelaChatPanel";

/** Global Bela widget — same UX as belpower-frontend (FAB + chat drawer). */
export default function BelaChatWidget({ children }) {
  return (
    <BelaChatProvider>
      {children}
      <BelAiChat />
      <BelaChatPanel />
    </BelaChatProvider>
  );
}

export { useBelaChat, BELSOFT_SUPPORT_WHATSAPP } from "./BelaChatContext";
